import { ReactNode } from "react"
import { Container } from "reactstrap"
import LoadingState from "Components/organisms/loading-state"
import DetailPageHeader from "Components/molecule/cards/detail-page-header"
import ActionButton from "Components/atoms/buttons/action-button"
import Department from "models/department"
import Breadcrumb from "Components/organisms/breadcrumb"
import { HelpIcon, PencilIcon, TrashIcon } from "Components/atoms/icons"

interface DepartmentDetailTemplateProps {
    department: Department | null
    isLoadingDepartment: boolean
    // Tabs (KPIs, External Mapping, Access Control) under the department header
    content: ReactNode
    handleBack: () => any
    handleEdit?: () => any
    handleDelete?: () => any
    handleOpenHelpDocument?: () => any
}

const DepartmentDetailTemplate = ({
    department,
    isLoadingDepartment,
    content,
    handleBack,
    handleEdit,
    handleDelete,
    handleOpenHelpDocument
}: DepartmentDetailTemplateProps) => {
    return <div className="page-content">
        <Container fluid style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <Breadcrumb
                title={"Admin"}
                breadcrumbItem={"Department Details"}
                actions={<>
                    <ActionButton onClick={handleBack}>
                        Back
                    </ActionButton>
                    {handleEdit && <ActionButton onClick={handleEdit}>
                        Edit <PencilIcon />
                    </ActionButton>}
                    {handleDelete && <ActionButton className="bg-danger" onClick={handleDelete}>
                        Delete <TrashIcon className="text-white" />
                    </ActionButton>}
                    {handleOpenHelpDocument && (
                        <ActionButton onClick={() => handleOpenHelpDocument()}>
                            Help <HelpIcon />
                        </ActionButton>
                    )}
                </>}
            />
            {
                isLoadingDepartment || !department ?
                    <div className="section-container">
                        <LoadingState
                            title="Loading Department"
                            subtitle="Fetching department details..."
                        />
                    </div>
                    :
                    <>
                        {/* The department colour is a small swatch next to the name, not a full-width band */}
                        <DetailPageHeader
                            fullWidth
                            title={<span className="d-inline-flex align-items-center gap-2">
                                <span className="department-color-dot" style={{ backgroundColor: department.color ?? 'transparent', width: 14, height: 14, flexBasis: 14 }} title={department.color ?? undefined} />
                                {`${department.code} — ${department.description}`}
                            </span>}
                            rows={[
                                { label: "Level", value: department.departmentLevel?.description ?? "-" },
                                { label: "Parent", value: department.parentDepartment ? `${department.parentDepartment.code} — ${department.parentDepartment.description}` : "-" },
                                { label: "Head", value: department.departmentHead ? (department.departmentHead.commonName ?? `${department.departmentHead.firstName} ${department.departmentHead.lastName}`) : "-" },
                                { label: "Your Access", value: department.yourPermission ?? "-" },
                            ]}
                        />
                        <div className="section-container">
                            {content}
                        </div>
                    </>
            }
        </Container>
    </div>
}

export default DepartmentDetailTemplate
